import { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { ApiError } from '../core/data/restClient';

/**
 * Filet pour les écritures qui échouaient en silence (#66 : glisser dans le
 * calendrier, suppression du tracker, assistant de projet). Toutes passent par
 * restClient ; un échec qu'aucun écran n'intercepte devient un
 * `unhandledrejection`, dont l'ApiError porte déjà un message traduit.
 * Un écran qui affiche lui-même l'erreur l'a interceptée : rien ne s'affiche
 * deux fois.
 */
export default function ApiErrorSnackbar() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const onRejection = (e: Event) => {
      const reason = (e as PromiseRejectionEvent).reason;
      if (reason instanceof ApiError) setMessage(reason.message);
    };
    window.addEventListener('unhandledrejection', onRejection);
    return () => window.removeEventListener('unhandledrejection', onRejection);
  }, []);

  return (
    <Snackbar
      open={message !== null}
      autoHideDuration={8000}
      onClose={() => setMessage(null)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity="error" variant="filled" onClose={() => setMessage(null)}>
        {message}
      </Alert>
    </Snackbar>
  );
}
